import { render, staticRenderFns } from "./ib-badge2.vue?vue&type=template&id=fe19c660&lang=pug&"
import script from "./ib-badge2.vue?vue&type=script&lang=js&"
export * from "./ib-badge2.vue?vue&type=script&lang=js&"
import style0 from "./ib-badge2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe19c660')) {
      api.createRecord('fe19c660', component.options)
    } else {
      api.reload('fe19c660', component.options)
    }
    module.hot.accept("./ib-badge2.vue?vue&type=template&id=fe19c660&lang=pug&", function () {
      api.rerender('fe19c660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/ib-badge2.vue"
export default component.exports